
import { Component, Prop, Vue } from 'vue-property-decorator'
import ChoiceIcon from '~/components/common/icon/ChoiceIcon.vue'

@Component({
  name: 'Radio',
  components: {
    ChoiceIcon
  },
  model: {
    prop: 'data'
  }
})
export default class Radio extends Vue {
  @Prop({ type: String, default: 'p' }) el!: string
  @Prop({ type: String, default: '' }) id!: string
  @Prop({ type: String, default: '' }) name!: string
  @Prop({ default: '' }) value!: string
  @Prop({ type: Boolean, default: false }) disabled!: boolean
  @Prop({ type: Boolean, default: false }) checked!: boolean
  @Prop({ default: '' }) data!: string

  mounted() {
    if (this.checked) {
      this.emitState()
    }
  }

  get isChecked() {
    return this.data === this.value
  }

  emitState() {
    this.$emit('input', this.value)
  }

  change() {
    this.emitState()
  }
}
